/**
 * @file Re-exports the personal access tokens table component.
 */
import PersonalAccessTokensTable from "./PersonalAccessTokensTable";

export default PersonalAccessTokensTable;

export { PersonalAccessTokensTable };
